// Shared Cloudflare Turnstile loader. Loads the API once (explicit-render mode) and renders
// widgets on demand, coordinating across footer.js (catalog), product.js (quote/proof) and any
// full-page widgets (e.g. the sample basket). Exposed as window.pnowTurnstile so those scripts
// share a single API load instead of each injecting their own — previously two loaders on the
// same page could clash on the shared onload hook / auto-vs-explicit render mode. This IIFE runs
// at footer.js parse time (footer.js is included on every page via the cobrand layouts), so the
// helper is available to any later script that uses it after DOMContentLoaded.
(function () {
    if (window.pnowTurnstile) return;

    var API_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
    var requested = false;
    var pending = [];

    function apiReady() {
        return window.turnstile && typeof window.turnstile.render === 'function';
    }

    function flush() {
        while (pending.length) {
            var fn = pending.shift();
            try { fn(); } catch (e) { /* never let one widget break the rest */ }
        }
    }

    // Turnstile invokes this once the API script finishes loading (explicit-render mode).
    window.__pnowOnTurnstileLoad = flush;

    function ensureApi() {
        if (apiReady()) { flush(); return; }
        if (requested) return; // load the API at most once per page
        requested = true;
        var s = document.createElement('script');
        s.src = API_SRC + '?onload=__pnowOnTurnstileLoad&render=explicit';
        s.async = true;
        s.defer = true;
        document.body.appendChild(s);
    }

    window.pnowTurnstile = {
        // Render `widget` (a .cf-turnstile element), calling onToken(token) when solved.
        // Safe to call repeatedly; each element is rendered at most once.
        render: function (widget, onToken) {
            if (!widget) return;
            var doRender = function () {
                if (widget.dataset.rendered === 'true' || !apiReady()) return;
                window.turnstile.render(widget, {
                    sitekey: widget.getAttribute('data-sitekey'),
                    callback: function (token) { if (typeof onToken === 'function') onToken(token); }
                });
                widget.dataset.rendered = 'true';
            };
            if (apiReady()) { doRender(); return; }
            pending.push(doRender);
            ensureApi();
        }
    };
})();

document.addEventListener('DOMContentLoaded', function () {
    //// OFFCANVAS CATALOG REQUEST FORMS START ////
    const offcanvasContent = document.getElementById("js-offcanvas-body");
    // validation variable
    let v;

    // --- Utility: push GTM/GA4 event safely (no PII) ---
    function pushGtmEventForFooter(eventName, params) {
        try {
            window.dataLayer = window.dataLayer || [];
            const payload = Object.assign({ event: eventName }, params || {});
            window.dataLayer.push(payload);
        } catch (_e) {
            // swallow; analytics should never break UX
        }
    }

    function loadValidationScripts() {
        let script1;
        // Check if script is already loaded in the DOM
        // prevent script from loading multiple times
        const existingScript = document.querySelector('script[src="/lib/asp-client-validation/aspnet-validation.min.js"]');
        if (!existingScript) {
            // Load external script
            script1 = document.createElement("script");
            script1.src = "/lib/asp-client-validation/aspnet-validation.min.js";
            script1.onload = function () {
                /// initialize validation
                v = new aspnetValidation.ValidationService();
                v.ValidationInputCssClassName = 'is-invalid';
                v.ValidationMessageCssClassName = 'invalid-feedback';
                v.bootstrap({ watch: true });
            };

            // Append to the document
            document.body.appendChild(script1);
        } else {
            /// initialize validation
            if (v) return;
            v = new aspnetValidation.ValidationService();
            v.ValidationInputCssClassName = 'is-invalid';
            v.ValidationMessageCssClassName = 'invalid-feedback';
            v.bootstrap({ watch: true });
        }
    }


    // The catalog form partial is injected via innerHTML, so the Cloudflare Turnstile <script>
    // tags inside it never execute. Render the widget explicitly via the shared loader instead.
    // No-op when Turnstile is disabled (DEBUG builds render no .cf-turnstile element).
    function initTurnstile() {
        const form = document.getElementById('requestCatalogForm');
        if (!form) return;
        const widget = form.querySelector('.cf-turnstile');
        if (!widget) return;
        const input = form.querySelector('#turnstile-token');
        window.pnowTurnstile.render(widget, function (token) {
            if (input) input.value = token;
        });
    }

    async function getOffcanvasContentForFooter(form) {
        const fetchUrl = `/partial/${form}`;

        if (offcanvasContent) {
            try {
                const response = await fetch(fetchUrl);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = await response.text();
                offcanvasContent.innerHTML = data;

            } catch (error) {
                console.error('Error fetching HTML:', error);
            }
        }
    }

    const catalogRequestButtons = document.querySelectorAll("[data-bs-toggle='offcanvas'][data-form='catalog']");

    if (catalogRequestButtons.length > 0) {
        catalogRequestButtons.forEach(button => {
            button.addEventListener("click", async function () {
                let form = this.getAttribute("data-form");

                // Add loading spinner
                offcanvasContent.innerHTML = `
                    <div class="d-flex justify-content-center my-5 tag-text-theme-primary">
                        <div class="spinner-border" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                `;

                if (form === "catalog") {
                    await getOffcanvasContentForFooter("requestcatalog");
                    loadValidationScripts();
                    initTurnstile();
                } else {
                    offcanvasContent.innerHTML = "Something went wrong. Please try again later.";
                }
            });
        });
    }

    // Offcanvas form container
    const formContainer = document.getElementById('js-offcanvas-body');

    // check for validation errors
    formContainer.addEventListener('click', (event) => {
        const fileUploadAlert = document.getElementById('js-uploadFileAlert');

        if (event.target && event.target.id === "requestCatalogBtn") {
            if (!v || !v.isValid(document.getElementById('requestCatalogForm'))) {
                setTimeout(() => {
                    const el = document.querySelector('.tag-request-validation-form');
                    if (el) {
                        el.scrollIntoView({ behavior: "smooth", block: "start" });
                    }
                }, 50);
            }
        }
    });

    // Show a submit error without destroying the form, so the user can correct and retry. Refreshes
    // the single-use Turnstile token (a spent/expired token would otherwise fail every retry).
    function showOffcanvasFormError(status) {
        const alertEl = document.querySelector('#js-offcanvas-body .tag-request-validation-form');
        let text;
        if (status === 429) {
            text = "You've made several requests recently. Please wait a moment and try again.";
        } else if (status === 400) {
            text = "We couldn't verify your submission. Please complete the verification and try again.";
        } else {
            text = "Something went wrong and your form was not submitted. Please try again.";
        }
        if (alertEl) {
            alertEl.textContent = text;
            alertEl.style.display = 'block';
            alertEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        if (window.turnstile && typeof window.turnstile.reset === 'function') {
            try { window.turnstile.reset(); } catch (e) { /* ignore */ }
        }
    }

    // --- Submit helper: POST then push GTM event on success ---
    async function submitQuoteProofForm(url, formData, msg, formEl) {
        const formBody = document.getElementById('js-offcanvas-body');

        try {
            const response = await fetch(url, {
                method: 'POST',
                body: formData
            });

            if (!response.ok) {
                showOffcanvasFormError(response.status);
                return;
            }

            // Success UI
            formBody.innerHTML = msg;

            // ---- FIRE GA4/GTM EVENT *AFTER SUCCESS* ----
            // const addressType = formEl?.querySelector('[name="AddressType"]:checked')?.value;
            let addressType = null;

            if (formEl) {
                const checked = formEl.querySelector('[name="AddressType"]:checked');
                addressType = checked ? checked.value : null;
            }

            pushGtmEventForFooter('catalog_request', {
                page_path: location.pathname + location.search,
                address_type: addressType || undefined
            });

        } catch (error) {
            console.error('Error submitting form:', error);
        }
    }

    formContainer.addEventListener("submit", async function (event) {

        if (event.target && event.target.id === "requestCatalogForm") {
            event.preventDefault();

            if (!v || v.isValid(document.getElementById('requestCatalogForm'))) {
                const url = '/partial/RequestCatalog';
                const formEl = event.target;                           // keep reference BEFORE we replace DOM
                const formData = new FormData(formEl);
                const msg = '<div class="h5">Thank you for your catalog request.</div>';

                await submitQuoteProofForm(url, formData, msg, formEl);
            }
        }
    });
    //// OFFCANVAS CATALOG REQUEST FORMS END ////
});
